if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const allMedia = this.querySelectorAll('[data-media-id]');
        const clickedMediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(`[data-media-id="${clickedMediaId}"]`);

        // Hide all media except the clicked one
        allMedia.forEach((element) => {
          if (element.getAttribute('data-media-id') === clickedMediaId) {
            element.classList.add('active');
            element.style.display = 'block'; // Ensure the clicked image is visible
          } else {
            element.classList.remove('active');
            element.style.display = 'none'; // Hide other images
          }
        });

        // Scroll the clicked media into view
        if (activeMedia) {
          activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });

          const container = this.querySelector('[role="document"]');
          if (container) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }

          // Handle deferred content (e.g., videos)
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          if (
            activeMedia.nodeName === 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }
      }
    }
  );
}
